import React from 'react';

import { type UseInfiniteQueryOptions, useInfiniteQuery } from '@lumapps/base-api/react-query';
import { listDocuments, type ListDocumentsParams, documentsQueryKeys } from '@lumapps/medias-document/api';
import { useSelector } from '@lumapps/redux/react';
import { currentLanguageSelector } from '@lumapps/translations/ducks/selectors';

const DEFAULT_MAX_RESULTS = 30;

/**
 * Hook to get the list of all media items.
 * @returns: a react-query query Object
 */
export const useMediaList = (params: ListDocumentsParams, options?: UseInfiniteQueryOptions) => {
    const lang = useSelector(currentLanguageSelector);

    const defaultParams = React.useMemo(() => ({ lang, maxResults: DEFAULT_MAX_RESULTS, ...params }), [lang, params]);

    return useInfiniteQuery({
        ...options,
        queryKey: documentsQueryKeys.list(defaultParams),
        queryFn: ({ pageParam, signal }) => listDocuments({ ...defaultParams, cursor: pageParam }, signal),
        getNextPageParam: (lastPage) => lastPage.more && lastPage.cursor,
    });
};
